<template>
  <div class="overflow" style="padding: 30px;height: 100%;overflow:auto;">
    <div class="settingDiv">
      <div style="color: rgb(7, 230, 248); height: 40px">
        系统联动设置
        <a type="text" size="mini" @touchstart="updateLinkage()" @click="updateLinkage()" style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row v-for="(item,key) in linkage" :key="key" style="margin-left: 1%; margin-top: 3px; padding-bottom:1%;">
        <el-col :lg="3" :md="3" :sm="4" :xl="2" :xs="12">联动{{ item.appName }}：</el-col>
        <el-col :lg="12" :md="12" :sm="12" :xl="20" :xs="10" style="margin-left: -10px">
          <el-col v-if="item.autoApprove == 'true'" :xl="8" :lg="10" :md="10" :sm="12" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col v-else :xl="8" :lg="10" :md="10" :sm="12" :xs="10"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244, 96, 108); float: left;"></el-col>
          <el-col v-if="item.autoApprove == 'true'" :xl="8" :lg="10" :md="10" :sm="12" :xs="12"
                  style="margin-left: 1%;">已启用
          </el-col>
          <el-col v-else :xl="8" :lg="10" :md="10" :sm="12" :xs="12" style="margin-left: 1%;">未启用</el-col>
        </el-col>
      </el-row>
    </div>

    <!--    弹出窗-->
    <function-dialog-component
      :dialog-title="title"
      :dialogVisible.sync="linkageDialogVisible"
      :width-list="[{
            innerWidth: 1020,
            width: '40%'
          }]"
      width="35vw"
      center
      @dialogClose="(data) => this.linkageDialogVisible = data">
      <div slot="content" style="padding: 10px 30px 20px 30px;height: 28vh">
        <edit-linkage @event="checkup" :linkageData="linkage"/>
        <div slot="footer" class="dialog-footer" style="text-align: center; margin-top: 30px;">
          <el-button @touchstart="closeLinkage" @click="closeLinkage" size="mini">关 闭</el-button>
          <el-button @touchstart="commitLinkage" @click="commitLinkage" size="mini">保 存</el-button>
        </div>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>

import EditLinkage from "@/views/basic_operations/sys_setting/linkage/EditLinkage";
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import {getSystematicByParent, saveOrUpdateApplication} from '@/network/systematic';

export default {
  name: "Linkage",
  components: {FunctionDialogComponent, EditLinkage},
  inject: ['overflow'],
  data() {
    return {
      linkage: {},
      tick_system: {},
      capacity_system: {},
      assets_system: {},
      edit_tick_system: {},
      edit_capacity_system: {},
      edit_assets_system: {},
      if_save: false,
      title: '',
      linkageDialogVisible: false,

      extSystematic: {
        parentId: 0,
        code: "",
        name: "",
        val1: "",
        val2: "",
        ordinal: "",
        isDisplay: true,
        icon1: "",
        icon2: "",
        note: "",
        spare: "",
        manageable: true
      },

    }
  },
  mounted() {
    this.overflow();
    this.getLinkage();
  },
  methods: {
    getLinkage() {
      //let codes = ["linkage"];
      getSystematicByParent().then(res => {
        this.linkage = res.data;
      })
    },

    updateLinkage() {
      this.title = '编辑系统联动设置';

      this.linkageDialogVisible = true;
    },
    //关闭
    closeLinkage() {
      this.linkageDialogVisible = false;
      this.getLinkage();
    },
    //保存
    commitLinkage() {
      this.commitSon();
    },
    checkup(data) {
      this.if_save = data;
    },
    //保存子配置
    commitSon() {
      if (this.if_save == false) {
        return;
      }
      saveOrUpdateApplication(this.linkage).then(res => {
        if (res.code === 0) {
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.getLinkage();
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
        this.linkageDialogVisible = false;
      })
    },

  }
}
</script>

<style scoped>

</style>
